<template>
  <a-card title="创建用户标签" :bordered="false">
    <a-form @submit="handleSubmit" :form="form">
      <a-form-item
        label=标签名称
        :wrapper-col="{ span: 12}"
        v-bind="formItemLayout">
        <a-input
          v-decorator="[
            'name',
            {rules: [
              { required: true, message: '请输入标签名称' },
              { max:8, message: '请输入8位以内有效名称'}
              ],
            initialValue: name}
          ]"
          style="width: 400px;"
          placeholder="请输入"/>
      </a-form-item>
      <a-form-item
        label="标签类型"
        v-bind="formItemLayout"
      >
        <a-radio-group
          @change="onChangeRadio"
          v-decorator="[
            'type',
            {rules: [{ required: true, message: '请选择标签类型' }],
            initialValue:radioValue}
          ]">
          <a-radio v-for="item in radioList" :key="item.code" :value="item.code">{{ item.name }}</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="标签规则" v-if="radioValue !== 1" v-bind="formItemLayout">
        <p style="font-size:12px;">可根据不同规则配置自动标签，若该用户不再满足规则，则次日或次月会自动移除标签</p>
        <a-select
          style="width:150px;margin-right:20px;"
          @change="selectChanged"
          placeholder="请选择标签规则"
          v-decorator="[
            'ruleType',
            {initialValue:selectedValue}
          ]">
          <a-select-option v-for="item in selectedList" :key="item.code" :value="item.code">{{ item.name }}
          </a-select-option>
        </a-select>
        <span>{{ prefix }}</span>大于
        <a-input
          style="width:80px;margin: 0 20px;"
          v-decorator="[
            'ruleValue',
            {initialValue:ruleValue}
        ]"
        ></a-input>
        <span>{{ suffix }}</span>,即标记
      </a-form-item>
      <a-form-item
        :wrapper-col="{ span: 12, offset: 4}"
      >
        <a-button htmlType="submit" type="primary">提交</a-button>
        <a-button @click="back" style="margin-left:10px">取消</a-button>
      </a-form-item>
    </a-form>
  </a-card>
</template>

<script>
export default {
  name: 'BaseForm',
  data() {
    return {
      formItemLayout: {
        labelCol: {
          span: 4
        },
        wrapperCol: {
          span: 20
        }
      },
      radioList: [],
      rowData: {},
      id: '',
      name: '',
      selectedValue: 1,
      ruleValue: 1,
      radioValue: 2,
      selectedList: [],
      prefix: '累计支付',
      suffix: '笔',
      form: this.$form.createForm(this)
    }
  },
  mounted() {
    this.id = this.$route.query.id
    this.radioList = this.getAppConstants().getUserTagType()
    this.selectedList = this.getAppConstants().getUserTagRuleType()
  },
  methods: {
    //提交
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.getLogUtils().logWithTag('Received values of form: ', values)
          this.getLogUtils().logWithTag('submitId', this.id)
          this.getHttpServices().getUserService().post('api/v2/member/tag/submit', values)
            .then(res => {
              this.$router.go(-1)
              this.$message.success('提交成功')
            }).catch(reason => {
            this.$message.error('提交失败')
            this.showNetWorkErrorMessage(reason)
          })
        }
      })
    },
    selectChanged(value) {
      if (value == 1) {
        this.prefix = '累计支付'
        this.suffix = '笔'
      } else if (value == 2) {
        this.prefix = '累计支付'
        this.suffix = '元'
      } else if (value == 3) {
        this.prefix = '累计访问'
        this.suffix = '天'
      } else if (value == 4) {
        this.prefix = '平均单价'
        this.suffix = '元'
      } else {
        this.prefix = '平均支付'
        this.suffix = '笔'
      }
    },
    onChangeRadio(e) {
      this.radioValue = e.target.value
      this.getLogUtils().logWithTag('this.radioValue:', this.radioValue)
    },
    back() {
      this.$router.go(-1)
    }
  }
}
</script>
